var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicencie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 22.645,
    height: 17.019,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "licencie",
    transform: "translate(-729 -680)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(729 680)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11383",
    "data-name": "Groupe 11383",
    transform: "translate(734.898 688.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11382",
    "data-name": "Groupe 11382",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_672",
    "data-name": "Trac\\xE9 672",
    d: "M22.525,39.279a2.8,2.8,0,0,0-2.378.116,2.639,2.639,0,0,0-.82.679,10.235,10.235,0,0,0,.255-2.334c.052,0,.1,0,.157,0a2.81,2.81,0,0,0,2.8-3.058.191.191,0,0,0-.175-.175,2.809,2.809,0,0,0-2.888,1.821,10.123,10.123,0,0,0-.287-1.326c0-.01-.007-.018-.01-.028a2.81,2.81,0,0,0-1.3-3.929.194.194,0,0,0-.239.065,2.809,2.809,0,0,0,.925,4.034.316.316,0,0,0,.006.034,9.495,9.495,0,0,1,.349,1.989c.007.125.014.252.016.379a9.643,9.643,0,0,1-.475,3.246c-.025.076-.05.15-.078.228s-.049.137-.079.216l-.007.021a10.238,10.238,0,0,1-.482,1.07A2.445,2.445,0,0,0,16.5,41.3L14.627,40.7a1.5,1.5,0,0,1-.214-.094.287.287,0,0,0-.384.124,3.192,3.192,0,0,1-2.76,1.672,2.991,2.991,0,0,1-2.658-1.664.287.287,0,0,0-.386-.129,1.473,1.473,0,0,1-.211.092L6.148,41.3a2.443,2.443,0,0,0-1.32,1.027,9.956,9.956,0,0,1-.482-1.072c-.03-.078-.059-.155-.087-.237s-.052-.15-.076-.223a9.654,9.654,0,0,1-.476-3.25c0-.12.008-.249.017-.383a9.511,9.511,0,0,1,.348-1.984.325.325,0,0,0,.006-.034A2.809,2.809,0,0,0,5,31.114a.193.193,0,0,0-.237-.065,2.808,2.808,0,0,0-1.3,3.928.3.3,0,0,0-.011.029,10.156,10.156,0,0,0-.286,1.326,2.808,2.808,0,0,0-2.888-1.82.191.191,0,0,0-.175.175,2.81,2.81,0,0,0,2.8,3.058c.052,0,.1,0,.157,0a10.25,10.25,0,0,0,.255,2.333,2.632,2.632,0,0,0-.819-.678A2.8,2.8,0,0,0,.12,39.279.192.192,0,0,0,0,39.5,2.813,2.813,0,0,0,1.44,41.4a3.033,3.033,0,0,0,1.409.353,2.7,2.7,0,0,0,.935-.164,10.59,10.59,0,0,0,.693,1.443.317.317,0,0,0,.039.052,2.473,2.473,0,0,0-.064.558v1.6a.539.539,0,0,0,.539.539H17.654a.539.539,0,0,0,.539-.539v-1.6a2.465,2.465,0,0,0-.064-.558.316.316,0,0,0,.04-.054,10.935,10.935,0,0,0,.691-1.441,2.7,2.7,0,0,0,.936.164A3.033,3.033,0,0,0,21.2,41.4a2.805,2.805,0,0,0,1.436-1.9.193.193,0,0,0-.116-.218",
    transform: "translate(0 -28.76)",
    fill: "#2341d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_673",
    "data-name": "Trac\\xE9 673",
    d: "M109.182,2.674l.573-.572a1.467,1.467,0,0,1,1.732-.254l.327.176a1.062,1.062,0,0,0,1.011,0l.308-.168a1.467,1.467,0,0,1,1.733.244l.6.589a.121.121,0,0,0,.2-.117,3.461,3.461,0,0,0-6.686-.011.121.121,0,0,0,.2.117",
    transform: "translate(-100.998)",
    fill: "#2341d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_674",
    "data-name": "Trac\\xE9 674",
    d: "M100.143,32.661c.189,0,.2.145.208.408a2.948,2.948,0,0,0,.806,2.042l.006.006q.055.058.113.113c.041.04.082.076.124.111a2.969,2.969,0,0,0,3.844,0c.041-.035.082-.071.122-.11a2.946,2.946,0,0,0,.926-2.154c.012-.272.019-.417.208-.417a.766.766,0,0,0,.743-.567,1.22,1.22,0,0,0,.062-.967.477.477,0,0,0-.37-.217.191.191,0,0,1-.167-.189l.012-.972a.36.36,0,0,0-.107-.261l-1.077-1.062a1.082,1.082,0,0,0-1.278-.18l-.308.168a1.447,1.447,0,0,1-1.378,0l-.327-.176a1.082,1.082,0,0,0-1.277.187l-1.059,1.058a.36.36,0,0,0-.105.259l.013.974a.191.191,0,0,1-.167.189.477.477,0,0,0-.37.217,1.219,1.219,0,0,0,.062.967.767.767,0,0,0,.743.567",
    transform: "translate(-91.997 -26.055)",
    fill: "#2341d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_675",
    "data-name": "Trac\\xE9 675",
    d: "M124.9,133.6a3.34,3.34,0,0,1-3.74,0,.15.15,0,0,0-.235.123v.618c0,.379-.122.481-.346.778a.221.221,0,0,0-.035.213,2.629,2.629,0,0,0,2.433,1.718,2.792,2.792,0,0,0,2.537-1.718.22.22,0,0,0-.034-.213c-.223-.3-.344-.4-.344-.777v-.618a.15.15,0,0,0-.235-.123",
    transform: "translate(-111.705 -123.8)",
    fill: "#2341d0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicencie);
export default __webpack_public_path__ + "static/media/licencie.e8ddd98a2cbc1c48627494b3f0c20b5e.svg";
export { ForwardRef as ReactComponent };